var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClockFilled = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99622 16C12.3907 16 16 12.3983 16 8.00378C16 3.60925 12.3907 0 7.99622 0C3.6017 0 0 3.60925 0 8.00378C0 12.3983 3.60925 16 7.99622 16ZM4.44738 9.18924C4.03209 9.18924 3.69986 8.85701 3.69986 8.43417C3.69986 8.01888 4.03209 7.68664 4.44738 7.68664H7.2487V3.78292C7.2487 3.36008 7.57338 3.03539 7.99622 3.03539C8.41907 3.03539 8.74375 3.36008 8.74375 3.78292V8.43417C8.74375 8.85701 8.41907 9.18924 7.99622 9.18924H4.44738Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClockFilled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ClockFilled.651b054c95f3defa27ffa411f8054ca4.svg";